import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { node, oneOfType, string } from 'prop-types';

import { isProduction } from '@ajaibid/utils';

const queryClient = new QueryClient();

const ReactQuery = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    {children}
    {!isProduction() && <ReactQueryDevtools />}
  </QueryClientProvider>
);

ReactQuery.defaultProps = {
  children: null,
};

ReactQuery.propTypes = {
  children: oneOfType([node, string]),
};

export default ReactQuery;
